import axios from "axios";

/**
 * Persist access/refresh tokens and sync the default Axios Authorization header.
 * Pass `undefined` for refreshToken to leave the stored refresh token unchanged.
 */
export function setAuthTokens(accessToken, refreshToken) {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;
  }
  if (refreshToken !== undefined) {
    if (refreshToken) {
      localStorage.setItem("refreshToken", refreshToken);
    } else {
      localStorage.removeItem("refreshToken");
    }
  }
}

export function clearAuthTokens() {
  setAuthTokens(null, null);
}
